import React, { useCallback, useState } from 'react';
import { MessageCircleIcon, RotateCcwIcon } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { brand } from '../../data/config';
import { legalDocs, supportDoc, withdrawalDoc, type LegalDoc } from '../../data/legal';
const footerCopy = {
  description: 'Materiales digitales para momentos especiales.',
  copyright: `© 2026 ${brand}. Todos los derechos reservados.`
};
const linkClass = 'text-left text-[14.5px] font-medium text-body underline-offset-4 transition-colors duration-150 hover:text-[#4A3A35] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E74D7A] rounded';
export function SiteFooter() {
  const [openDoc, setOpenDoc] = useState<LegalDoc | null>(null);
  const close = useCallback(() => setOpenDoc(null), []);
  const legalLinks = legalDocs.filter(d => d.id !== withdrawalDoc.id);
  return <footer className="border-t border-[#EADFCF] bg-[#F8ECDF]" data-id="element-334" data-mp="151nadq7nqvpm">
      <div className="mx-auto grid max-w-5xl gap-8 px-5 py-10 sm:px-6 md:grid-cols-[1.3fr_1fr_1fr] md:gap-10 md:py-12" data-id="element-335" data-mp="150vm70ge409d">
        <div data-id="element-336" data-mp="3dsc4xkq6yafj">
          <p className="font-display text-[18px] font-extrabold text-[#4A3A35]" data-id="element-337" data-mp="38vu1co6lki4s">{brand}</p>
          <p className="mt-1.5 max-w-xs text-[14.5px] leading-relaxed text-body" data-id="element-338" data-mp="3mmz4w1d35uke">{footerCopy.description}</p>
          
        </div>

        <nav aria-label="Información legal" data-id="element-339" data-mp="3imgbw3zgiigm">
          <h2 className="text-[12px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55]" data-id="element-340" data-mp="3inhy94lxardn">Legal</h2>
          <ul className="mt-3 space-y-2" data-id="element-341" data-mp="2uxnmyrh95avi">
            {legalLinks.map(doc => <li key={doc.id} data-id="element-342" data-mp="2pyaqrg4hqrg9">
                <button type="button" onClick={() => setOpenDoc(doc)} aria-haspopup="dialog" className={linkClass} data-id="element-343" data-mp="2pz2oawhnez96">
                  {doc.title}
                </button>
              </li>)}
            <li data-id="element-344" data-mp="2yziq81iqtybx">
              
            </li>
          </ul>
        </nav>

        <div data-id="element-345" data-mp="j4p1uk7moru8">
          <h2 className="text-[12px] font-extrabold uppercase tracking-[0.08em] text-[#8B6B55]" data-id="element-346" data-mp="j4fez5hvr0sr">Atención al cliente</h2>
          <button type="button" onClick={() => setOpenDoc(supportDoc)} aria-haspopup="dialog" className={`mt-3 inline-flex items-center gap-2 ${linkClass}`} data-id="element-347" data-mp="37z5ec5wl51lg">
            <MessageCircleIcon className="h-4 w-4 text-[#E74D7A]" aria-hidden="true" data-id="element-348" data-mp="3cworf2hjr8bt" />
            {supportDoc.title}
          </button>
        </div>
      </div>

      <div className="border-t border-[#EADFCF]" data-id="element-349" data-mp="3lzg75ehggq99">
        <p className="mx-auto max-w-5xl px-5 py-4 text-center text-[13px] text-body sm:px-6 md:text-left" data-id="element-350" data-mp="3ly51f94g98fi">{footerCopy.copyright}</p>
      </div>

      <LegalModal doc={openDoc} onClose={close} data-id="element-351" data-mp="2t9zeqgtu59d1" />
    </footer>;
}